import React from "react";
import { useNavigate } from "react-router-dom";
export default function ExchangeReturnPolicy() {
  const pageWrapperStyle = {
    minHeight: "100vh",
    padding: "7rem 0.75rem", 
    backgroundColor: "#f9fafb", 
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    maxWidth: "1024px", 
    margin: "0 auto", 
    padding: "2.5rem",
    borderRadius: "1rem",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 10px rgba(0, 0, 0, 0.05)", 
    fontFamily: "'Inter', sans-serif",
  };

  const titleStyle = {
    fontWeight: "800",
    fontSize: "2.25rem", 
    textAlign: "center",
    marginBottom: "2.5rem",
    color: "#dc2626", 
  };

  const sectionHeadingStyle = {
    fontSize: "1.5rem", 
    fontWeight: "700",
    marginTop: "2rem", 
    marginBottom: "1rem", 
    color: "#1f2937", 
    borderBottom: "2px solid #fbbf24",
    paddingBottom: "0.5rem",
  };

  const textStyle = {
    fontSize: "1rem", 
    lineHeight: "1.625", 
    color: "#4b5563", 
    marginBottom: "1.5rem", 
  };

  const listStyle = {
    listStyleType: 'disc',
    paddingLeft: '1.25rem', 
  };

  const listItemStyle = {
    marginBottom: '0.5rem', 
  };

  const infoBoxStyle = {
    backgroundColor: "#eff6ff", 
    borderLeft: "4px solid #60a5fa", 
    color: "#1e40af",
    padding: "1rem", 
    borderRadius: "0.5rem",
    marginTop: "0.75rem",
  };

  const warningBoxStyle = {
    backgroundColor: "#fffbeb",
    borderLeft: "4px solid #fbbf24", 
    color: "#92400e", 
    padding: "1rem", 
    borderRadius: "0.5rem",
    marginTop: "1rem", 
  };

  const linkStyle = {
    color: "#dc2626",
    textDecoration: "none",
    fontWeight: "600",
  };
  
  const buttonContainerStyle = {
    textAlign: "center",
    marginTop: "2.5rem", 
  };

  const buttonStyle = {
    backgroundColor: "#dc2626", 
    color: "white",
    fontWeight: "600", 
    padding: "0.75rem 2rem", 
    borderRadius: "9999px", 
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)", 
    transition: "all 0.3s ease",
    border: 'none',
    cursor: 'pointer',
  };

  const navigate = useNavigate();

  return (
    <div style={pageWrapperStyle}>
      <div style={cardStyle}>
        <h2 style={titleStyle}>
           Exchange & Return Policy
        </h2>

        <div>
          <h3 style={sectionHeadingStyle}>
            1. Contact Information & Office Hours
          </h3>
          <div style={textStyle}>
            <p>Our team is available to assist you during the following hours:</p>
            <p style={{ ...textStyle, fontWeight: "700", marginBottom: '0.25rem' }}>Office Hours:</p>
            <ul style={listStyle}>
              <li style={listItemStyle}><b>Monday to Saturday</b></li>
              <li style={listItemStyle}><b>10:00 AM to 2:00 PM</b> and <b>3:00 PM to 6:00 PM</b> (IST)</li>
            </ul>
            <p style={{ ...textStyle, fontWeight: "700", marginTop: "1rem" }}>Customer Care Number: 9082826596</p>
            <p style={infoBoxStyle}>
              We only assist with queries during our working hours. If you call outside of these hours, we will revert the next day if bandwidth permits, or we request you to call us again during our operational time.
            </p>
            <p style={warningBoxStyle}>
              <b>Important:</b> Kindly <b>do not message</b> us on the WhatsApp number used for order confirmation and tracking. Messages to that number are <b>not monitored</b>. Please contact us via:
              <br />
              - <b>Instagram:</b> <a href="https://instagram.com/elite_clothings_hyd" target="_blank" rel="noopener noreferrer" style={linkStyle}>@elite_clothings_hyd</a>
              <br />
              - <b>Email:</b> <a href="mailto:support@eliteclothings.in" style={linkStyle}>support@eliteclothings.in</a>
            </p>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            2. General Exchange Window
          </h3>
          <div style={textStyle}>
            <p>
              Once your product is delivered, you must notify us of any exchange request within 3 days of delivery. Requests submitted after this 3-day window are strictly not eligible for exchange.
            </p>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            3. Damage or Manufacturing Defect Claims
          </h3>
          <div style={textStyle}>
            <p>We accept exchanges for products with any damage or manufacturing defect, provided the following conditions are met:</p>
            <ul style={listStyle}>
              <li style={listItemStyle}>Unpacking Video is Mandatory: An unpacking video is required for any damage or missing item claims and will be considered the sole proof.</li>
              <li style={listItemStyle}>Reporting: You must reach out to us on our Instagram <a href="https://instagram.com/elite_clothings_hyd" target="_blank" rel="noopener noreferrer" style={linkStyle}>@elite_clothings_hyd</a> and send the image and unpacking video clearly showing the damage/defective area.</li>
              <li style={listItemStyle}>Process: Upon our confirmation, we will provide you with the return address and instructions.</li>
              <li style={listItemStyle}>Shipping Charges: We will reimburse the shipping charges once you send us the courier receipt. We do not offer a courier pickup service as we rely on third-party couriers.</li>
              <li style={listItemStyle}>Weight Check: Before dispatch, we measure the weight and mention it on the courier cover. For any missing item claims, the unpacking video must clearly show the weight of the parcel upon arrival.</li>
            </ul>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            4. Size Exchange (Customer Request)
          </h3>
          <div style={textStyle}>
            <p>
              If you have size issues, an exchange will be accepted. You must notify us on Instagram <a href="https://instagram.com/elite_clothings_hyd" target="_blank" rel="noopener noreferrer" style={linkStyle}>@elite_clothings_hyd</a> within 3 days of delivery.
            </p>
            <p>
              Customer Responsibility: Courier charges for returning the parcel to us must be paid by the customer to initiate the exchange process.
            </p>
            <p style={{ ...textStyle, marginTop: "0.75rem" }}>
              Sizing Help: If you have any doubts about choosing the right size, kindly message us with your recent measurements, and we will assist you in selecting the correct size before placing your order.
            </p>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            5. Exchange Due to Our Error (Wrong Item/Size Sent)
          </h3>
          <div style={textStyle}>
            <p>
              If we have sent you a wrong item or size, we will accept the exchange. This must be reported within 3 days of delivery.
            </p>
            <ul style={listStyle}>
              <li style={listItemStyle}>Upon our confirmation, we will provide the return address and procedure.</li>
              <li style={listItemStyle}>We will send you the shipping charges once you send the courier receipt. We do not offer courier pickup service.</li>
            </ul>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            6. Returns, Store Credit, and Limitations
          </h3>
          <div style={textStyle}>
            <ul style={listStyle}>
              <li style={listItemStyle}>Category Exchange: Exchange is generally not applicable between different product categories. We may consider an exception if the reason seems valid.</li>
              <li style={listItemStyle}>Other Reasons: We do not accept exchanges/returns for any other reasons unless the reason is deemed valid by our team.</li>
              <li style={listItemStyle}>Store Credit Only: If any product is returned by the customer, it is eligible for store credit only. We do not accept cash refund requests on any products sold at any time.</li>
              <li style={listItemStyle}>Stock Availability: In case the product for replacement is not available, the customer will be eligible for store credit equal to the value of the product, or they can choose any alternative product from our available collection. The amount will not be refunded.</li>
            </ul>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            7. Quality Check and Procedure
          </h3>
          <div style={textStyle}>
            <p>
              The exchange/replacement shipping will only be processed after the original item passes a mandatory quality check (Unused, unwashed & no smell). If the outfit came with a tag attached, it must be sent back with the tag intact.
            </p>
            <p>
              To initiate the exchange process, kindly message us on Instagram <a href="https://instagram.com/elite_clothings_hyd" target="_blank" rel="noopener noreferrer" style={linkStyle}>@elite_clothings_hyd</a> to confirm the process with our team.
            </p>
          </div>
        </div>

        <div style={buttonContainerStyle}>
          <button
            style={buttonStyle}
            onClick={() => navigate('/')}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}